<template>
  <div>
    <search-bar v-model="searchText" />
    <div class="flex my-2">
      <select
        v-model="selectedProject"
        class="p-2 bg-gray-200 rounded"
      >
        <option :value="null">
          {{ $t('Any Project', 'Any Project') }}
        </option>
        <option
          v-for="project in projects"
          :key="project.id"
          :value="project.id"
        >
          {{ project.name }}
        </option>
      </select>
      <select
        v-model="selectedLanguage"
        class="ml-2 p-2 bg-gray-200 rounded"
      >
        <option :value="null">
          {{ $t('Any Language', 'Any Language') }}
        </option>
        <option
          v-for="language in languages"
          :key="language.nickname"
          :value="language.nickname"
        >
          {{ language.name }}
        </option>
      </select>
      <select
        v-model="selectedPolarity"
        class="ml-2 p-2 bg-gray-200 rounded"
      >
        <option :value="null">
          {{ $t('Any Sentiment Score', 'Any Sentiment Score') }}
        </option>
        <option value="pos">
          {{ $t('Positive', 'Positive') }}
        </option>
        <option value="neg">
          {{ $t('Negative', 'Negative') }}
        </option>
        <option value="neu">
          {{ $t('Neutral', 'Neutral') }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchBar from '@/global/ui/SearchBar'

export default {
  components: { SearchBar },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: { type: Object, default: () => ({ projectId: null, language: null, polarity: null, searchText: '' }) }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.projects,
      languages: state => state.sentimentRules.languages
    }),
    selectedProject: {
      get () {
        return this.value.projectId
      },
      set (projectId) {
        this.$emit('change', { ...this.value, projectId })
      }
    },
    selectedLanguage: {
      get () {
        return this.value.language
      },
      set (language) {
        this.$emit('change', { ...this.value, language })
      }
    },
    searchText: {
      get () {
        return this.value.searchText
      },
      set (searchText) {
        this.$emit('change', { ...this.value, searchText })
      }
    },
    selectedPolarity: {
      get () {
        return this.value.polarity
      },
      set (polarity) {
        this.$emit('change', { ...this.value, polarity })
      }
    }
  }
}
</script>
